// Angular
import {
  Component,
  ChangeDetectionStrategy,
  OnInit,
  ViewChild,
  ChangeDetectorRef,
  inject,
  effect,
} from '@angular/core';
import { Data, Router } from '@angular/router';
import { filter, map } from 'rxjs';

// Material
import { MatDrawer } from '@angular/material/sidenav';

// 3rd party libs
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

// Libs
import { SAJ_ROUTES } from '@libs/types/navigation';
import { RouteContextService } from '@libs/services/route-context.service';
import { ReportingPageName } from '@libs/types';
import { HUB_PAGES_CONVERTED } from '@hub/page';
import { ViewportChangeService } from '@libs/services/viewport-change';
import { SidebarService } from '@hub/page';

@UntilDestroy()
@Component({
  templateUrl: 'mobile-layout.component.html',
  // tslint:disable-next-line:component-selector
  selector: 'snag-layout-mobile',
  styleUrls: ['./mobile-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileLayoutComponent implements OnInit {
  private readonly sidebarService = inject(SidebarService);
  @ViewChild('drawer') drawer: MatDrawer;
  isPageConverted = true;
  protected isDrawerOpen = this.sidebarService.isMobileOpened;

  constructor(
    private routeContextService: RouteContextService,
    private viewportService: ViewportChangeService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.setShouldHideHeader();
  }

  onBackdropClick() {
    this.sidebarService.isMobileOpened.update(() => false);
  }

  private setShouldHideHeader(): void {
    this.checkShouldHideHeaderOnRouteChange();
    this.checkShouldHideHeaderOnResize();
  }

  private checkShouldHideHeaderOnRouteChange(): void {
    this.routeContextService
      .getActivatedRouteData()
      .pipe(
        untilDestroyed(this),
        filter((data: Data) => data?.reportingPageName),
        map((data: Data) => data?.reportingPageName as ReportingPageName),
      )
      .subscribe((pageName: ReportingPageName) => {
        this.isPageConverted = this.isCurrentPageConverted(pageName);
        this.cdr.markForCheck();
      });
  }

  private checkShouldHideHeaderOnResize(): void {
    this.viewportService
      .isMobile()
      .pipe(untilDestroyed(this))
      .subscribe(() => {
        const currentRouteData: Data =
          this.routeContextService.getCurrentActivatedRouteData();
        this.isPageConverted = this.isCurrentPageConverted(
          currentRouteData.reportingPageName,
        );
        this.cdr.markForCheck();
      });
  }

  private isCurrentPageConverted(
    reportingPageName: ReportingPageName,
  ): boolean {
    return HUB_PAGES_CONVERTED.includes(reportingPageName);
  }
}
